import { render, staticRenderFns } from "./Multiple.vue?vue&type=template&id=30e399ea&"
import script from "./Multiple.vue?vue&type=script&lang=js&"
export * from "./Multiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/QuestionItem/Multiple.vue"
export default component.exports